'use client'
import { Provider } from 'react-redux'
import { persistor, store } from './store'
import { PersistGate } from 'redux-persist/integration/react'
import Preloader from '@/components/misc/Preloader'
import { usePathname } from 'next/navigation'
import OptionalView from '@/components/misc/OptionalView'
import ZohoWidget from '@/components/misc/ZohoWidget'
import { isProdEnv } from '@/lib/utils/misc/helperFns'


export default function ReduxStoreProvider({ children }: { children: React.ReactNode }) {
   const pathname = usePathname()
   const isDashboardRoute = pathname?.includes("user")

   return (
      <Provider store={store}>
         <PersistGate loading={<Preloader />} persistor={persistor}>
            {children}
            <OptionalView condition={isProdEnv && isDashboardRoute}>
               <ZohoWidget />
            </OptionalView>
         </PersistGate>
      </Provider>
   )
}